import { ModelBase } from 'store/model-base';

export class CmsPdp extends ModelBase {
    public static storeName: string = 'cmsPdp';

    public pdp: CmsPdpContent;
    public tradeInCheck: CmsTradeInCheck;
    public carousel: CmsShopModule;
}
